<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../library/scripts/styles.js'
	import { get_block_content, get_finished_content, delete_content } from '../library/scripts/utils.js'
	import {
		storeUploader,
		storeActiveBlock,
		storeUpdate,
		storeUpdateSingle,
		storeFinishedContent,
		storeShowFinishedBlocks,
		storeData,
		storeRooms,
		storeFoods,
		storeDrinks,
		storeShowMail,
		storeShop,
		storeBooking,
		storeShowCreateButtons,
		storeLinked,
	} from '../library/scripts/Store.svelte'
	import { url } from '../library/scripts/Setup.svelte'
	import FileUploader from '../library/FileUploader.svelte'
	import DropFiles from '../library/LayoutStuff/DropFiles.svelte'
	import TwoCols from '../library/columLayouts/TwoCols.svelte'
	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../modals/Alert.svelte'

	export let blockName = null

	//the configFile
	let configFile
	const stoData = storeData.subscribe((value) => {
		configFile = value
	})

	//active block
	const stoActiveBl = storeActiveBlock.subscribe((value) => {
		blockName = value
	})

	let blockTitle
	let showTitle = false
	let stBtnText = 'create title'

	//is this an update
	let isUpdate = false
	let closeUpdate = false
	let uploadCmd = 'upload'
	const stoUpdt = storeUpdate.subscribe((value) => {
		isUpdate = value
	})

	const globals = getContext('globals')
	const colorMain = globals.adminColorMain
	const fsN = globals.fsN
	const fsS = globals.fsS
	const fsL = globals.fsL
	const fsXS = globals.fsXS
	const inputBg = globals.adminInputBg
	const inputBgFocus = globals.adminInputBgFocus
	const buttonBgHover = globals.adminButtonBgHover

	let dropFiles = false
	let showDeletePrev = false
	let showCreateImage = true
	let deleteBlock = false
	let showSave = false

	let addImage = false

	//the accepted files
	const acceptedFiles = ['image/*']

	//only one image per slide
	let showError = false

	//error message
	let message = ''
	let showOkButton = false

	let uploadFiles
	const stoUp = storeUploader.subscribe((value) => {
		uploadFiles = value
	})

	//columns
	let bgImage = []

	//preview images
	let PREVHEIGHT = 80
	let PREVWIDTH = 60
	let PREVLANDSCAPE = 120

	let blocks = get_finished_content()
	blocks.then((value) => {
		storeFinishedContent.set({ finishedBlocks: value.finishedBlocks.sort(), linkedSites: value.linkedSites })
	})

	//update
	$: if (isUpdate) {
		closeUpdate = true
		storeShowCreateButtons.set(false)
		storeActiveBlock.set(blockName)
		uploadCmd = 'update'
		deleteBlock = true
		const blocks = get_block_content(blockName)
		blocks.then(function (value) {
			blockTitle = value[1].blockTitle
			showTitle = true
			stBtnText = 'delete title'

			//add the image
			if (value[1].menuBGIMG) {
				const imageFile = url + '/' + blockName + '/thumbnail/' + value[1].menuBGIMG
				dropFiles = true
				addImage = true
				showDeletePrev = true
				showCreateImage = false
				let image = new Image()
				image.src = imageFile
				image.onload = () => {
					let canvas = document.createElement('canvas')
					canvas.setAttribute('id', 'canv')
					let ctx = canvas.getContext('2d')

					if (image.width > image.height) {
						canvas.height = PREVHEIGHT
						canvas.width = PREVLANDSCAPE
					}

					if (image.width < image.height) {
						canvas.height = PREVHEIGHT
						canvas.width = PREVWIDTH
					}

					if (image.width === image.height) {
						canvas.height = PREVHEIGHT
						canvas.width = PREVHEIGHT
					}
					ctx.drawImage(image, 0, 0, canvas.width, canvas.height)
					const toWait = setTimeout(() => {
						const preview = document.querySelector('#prev_container')
						preview.append(canvas)
						storeUpdate.set(false)
						storeShowFinishedBlocks.set(false)
						showSave = true
						clearTimeout(toWait)
					}, 1)
				}
			} else {
				showCreateImage = true
			}
		})
	}

	//responsive
	$: if (window.innerWidth < 569) {
		PREVHEIGHT = 80
		PREVWIDTH = 27
		PREVLANDSCAPE = 120
	}

	$: if (window.innerWidth > 569) {
		PREVHEIGHT = 160
		PREVWIDTH = 120
		PREVLANDSCAPE = 240
	}

	//promisses
	let uploader = upload_block()

	//functions
	const show_title = () => {
		showTitle = showTitle === false ? true : false
		blockTitle = null
		if (!showTitle) stBtnText = 'create title'
	}

	const show_dropper = () => {
		addImage = true
		dropFiles = true
	}

	const save_block = () => {
		//error handling
		let error = false
		if (!blockTitle || blockTitle === '') {
			showError = true
			error = true
			message = 'please add title'
		}

		if (error) return
		if (closeUpdate) uploadCmd = 'update'

		switch (blockName) {
			case 'foods':
				storeFoods.set(false)
				break

			case 'drinks':
				storeDrinks.set(false)
				break

			case 'booking':
				storeBooking.set(false)
				break

			case 'rooms':
				storeRooms.set(false)
				break

			case 'mail':
				storeShowMail.set(false)
				break

			case 'shop':
				storeShop.set(false)
				break
		}

		uploadFiles = true
		storeUploader.set(true)
		uploader = upload_block()
		showSave = false
		storeShowFinishedBlocks.set(true)
		reset_all()
	}

	async function upload_block() {
		if (bgImage) return [{ id: blockName, image: bgImage[Object.keys(bgImage)] }]
		else return [{ id: blockName, image: null }]
	}

	const create_preview_image = () => {
		let reader = new FileReader()
		reader.readAsDataURL(bgImage[Object.keys(bgImage)])

		reader.onload = () => {
			let image = new Image()
			image.src = reader.result
			image.onload = () => {
				let canvas = document.createElement('canvas')
				canvas.setAttribute('id', 'canv')
				let ctx = canvas.getContext('2d')

				if (image.width > image.height) {
					canvas.height = PREVHEIGHT
					canvas.width = PREVLANDSCAPE
				}

				if (image.width < image.height) {
					canvas.height = PREVHEIGHT
					canvas.width = PREVWIDTH
				}

				if (image.width === image.height) {
					canvas.height = PREVHEIGHT
					canvas.width = PREVHEIGHT
				}
				ctx.drawImage(image, 0, 0, canvas.width, canvas.height)
				let preview = document.querySelector('#prev_container')
				preview.appendChild(canvas)
			}
		}
		// return ''
	}

	const delete_preview_image = () => {
		const image = document.querySelector('#canv')
		image.remove()
		dropFiles = false
		showDeletePrev = false
		showCreateImage = true
	}

	//redirection if updateSingle is true
	let updateSingle
	const stoUpdateSingle = storeUpdateSingle.subscribe((value) => {
		updateSingle = value
	})

	//close main window
	const close_window = () => {
		addImage = false
		const toWait = setTimeout(() => {
			storeShowFinishedBlocks.set(true)
			storeActiveBlock.set(null)
			if ($storeUpdateSingle) {
				const toClose = setTimeout(() => {
					document.location = '#/builder'
					clearTimeout(toClose)
				})
			}
			reset_all()
		}, 1)
	}

	//dispatch functions
	const check_file = (e) => {
		if (e.detail.error === 'true') {
			showError = true
			message = 'Sorry, only one image per column allowed'
			return
		}
		showDeletePrev = true
		bgImage = e.detail.files[0]
		create_preview_image()
	}

	const close_alert = () => {
		showError = false
	}

	const alert_delete = () => {
		showError = true
		message = 'delete entire block?'
		showOkButton = true
	}

	const alert_delete_block = async (blockName) => {
		closeUpdate = true
		const remainingBlocks = await delete_content(blockName)

		if (remainingBlocks) {
			showError = false
			remainingBlocks.sort()
			uploadCmd = 'upload'
			storeShowFinishedBlocks.set(true)
			storeFinishedContent.set({ finishedBlocks: remainingBlocks, linkedSites: $storeLinked.linkedSites })
			storeActiveBlock.set(null)
			switch (blockName) {
				case 'foods':
					storeFoods.set(true)
					break

				case 'drinks':
					storeDrinks.set(true)
					break

				case 'rooms':
					storeRooms.set(true)
					break
				case 'shop':
					storeShop.set(true)
					break
			}
			reset_all()
		}
	}

	const reset_all = () => {
		dropFiles = false
		storeUpdate.set(false)
		storeShowCreateButtons.set(true)
		bgImage = []
		addImage = true
		closeUpdate = false
		deleteBlock = false
		showSave = false
		deleteBlock = false
		showTitle = false
		stBtnText = 'create title'
	}

	onDestroy(() => {
		stoUpdateSingle
		stoActiveBl
		stoUp
		stoUpdt
		stoData
	})
</script>

{#if blockName && blockName !== 'mail'}
	<main id="updatemenu" use:styles={{ colorMain, fsN }} transition:slide={{ duration: 500 }}>
		<div class="block_title" use:styles={{ fsL, colorMain }}>{blockName}</div>

		<div class="button_container button_left">
			<button use:styles={{ colorMain, fsXS, buttonBgHover }} on:click={show_title}>{stBtnText}</button>
			{#if showTitle}
				<input
					type="text"
					use:styles={{ inputBg, inputBgFocus, colorMain, fsS }}
					placeholder="enter title"
					bind:value={blockTitle}
					data-input
				/>
			{/if}
		</div>
		{#if showCreateImage && blockName !== 'rooms' && blockName !== 'shop'}
			<div class="button_container button_left">
				<button use:styles={{ colorMain, fsXS, buttonBgHover }} on:click={show_dropper}>image</button>
				<div style="font-size:{fsS};margin-left:30px;">Add background-image to menu</div>
			</div>
		{/if}

		{#if addImage}
			<section transition:slide={{ duration: 1000 }}>
				<TwoCols>
					<div slot="column1" id="column_1">
						{#if dropFiles}
							<div style="margin-top:30px;" transition:slide={{ duration: 500 }}>
								{#if !showDeletePrev}
									<DropFiles on:upload={check_file} filesAccepted={acceptedFiles} allowedImages="1" />
								{:else}
									<button on:click={delete_preview_image} use:styles={{ colorMain, fsXS, buttonBgHover }}
										>delete image</button
									>
								{/if}
							</div>
						{/if}
					</div>

					<div slot="column2">
						{#if dropFiles}
							<div id="prev_container" class="prev_container" use:styles={{ inputBg }} in:slide={{ duration: 500 }} />
						{/if}
					</div>
				</TwoCols>
			</section>
		{/if}

		<div class="button_container">
			<button on:click={close_window} use:styles={{ colorMain, fsXS, buttonBgHover }}>close</button>
			{#if blockTitle}
				<button on:click={save_block} use:styles={{ colorMain, fsXS, buttonBgHover }}>save</button>
			{/if}
			{#if deleteBlock}
				<button on:click={alert_delete} use:styles={{ colorMain, fsXS, buttonBgHover }}>delete</button>
			{/if}
		</div>
	</main>
{/if}

{#if uploadFiles}
	{#await uploader then upload}
		<FileUploader files={upload} {blockTitle} />
	{/await}
{/if}

{#if showError}
	<Shader>
		<div slot="content">
			<Alert {message} {showOkButton} on:alertok={() => alert_delete_block(blockName)} on:alertclose={close_alert} />
		</div>
	</Shader>
{/if}

<style>
	main {
		width: 95vw;
		display: flex;
		flex-direction: column;
		padding: 2%;
		color: var(--colorMain);
		font-size: var(--fsN);
		user-select: none;
	}

	input[type='text'] {
		background-color: var(--inputBg);
		color: var(--colorMain);
		width: 90%;
		font-size: var(--fsS);
		border: 1px solid green;
	}

	input[data-input] {
		margin-left: 20px;
		width: 60%;
	}

	button {
		background-color: transparent;
		color: var(--colorMain);
		border: 1px solid var(--colorMain);
		font-size: var(--fsXS);
		width: clamp(100px, 13vw, 200px);
		margin-left: 1%;
		padding: 1%;
		border-radius: 5px;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonBgHover);
	}

	.button_container {
		display: flex;
		width: 100%;
		justify-content: center;
		align-items: center;
		border-top: 1px solid green;
		margin-top: 20px;
		padding-top: 25px;
	}

	.button_left {
		justify-content: flex-start;
	}

	/* preview container */
	.prev_container {
		display: flex;
		justify-content: center;
		align-items: center;
		background: var(--inputBg);
		margin-top: 30px;
		width: 300px;
		height: 200px;
	}

	.block_title {
		color: var(--colorMain);
		font-size: var(--fsL);
		text-transform: uppercase;
		font-weight: bold;
		margin: 20px 0px 20px 0px;
	}
</style>
